import { render, staticRenderFns } from "./RightClick.vue?vue&type=template&id=227c98ee&scoped=true"
import script from "./RightClick.vue?vue&type=script&lang=js"
export * from "./RightClick.vue?vue&type=script&lang=js"
import style0 from "./RightClick.vue?vue&type=style&index=0&id=227c98ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c98ee",
  null
  
)

export default component.exports